import { notFound } from "next/navigation";

export const handlerFetch = async (url: string) => {
  const headers = await getHeaders();

  const res = await fetch(process.env.NEXT_PUBLIC_API_BASE_URL + url, {
    headers: {
      ...headers,
    },
  });
  const data = await res.json();
  if (data.status === 400) return notFound();
  return data;
};



import axios, { AxiosProgressEvent, AxiosRequestConfig } from "axios";
import { showToast } from "../components/toast/showToast";
import { getToken } from "./action/MyCookies";

const getBrowserToken = () => {
  if (typeof document === "undefined") return null;

  const tokenCookie = document.cookie
    .split("; ")
    .find((row) => row.startsWith("admin-shop="));

  if (!tokenCookie) return null;

  try {
    const [, value] = tokenCookie.split("=");
    return decodeURIComponent(value ?? "");
  } catch (error) {
    console.error("Failed to read auth token from cookies", error);
    return null;
  }
};

const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;
type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

/*───────────────────────────── Header builder */
export const getHeaders = async (json = true) => {
  const token = typeof window === "undefined" ? await getToken() : getBrowserToken();
  const headers: Record<string, string> = {};
  if (json) headers["Content-Type"] = "application/json";
  if (token) headers.Authorization = `Bearer ${token}`;
  return headers;
};
const apiRequest = async (
  method: HttpMethod,
  url: string,
  data?: unknown,
  config: AxiosRequestConfig = {}
) => {
  const fullUrl = url.startsWith("http")
    ? url
    : `${baseUrl}${url.startsWith("/") ? "" : "/"}${url}`;

  const isMultipart = String(config.headers?.["Content-Type"] || "")
    .toLowerCase()
    .includes("multipart/form-data");

  const defaultHeaders = await getHeaders(!isMultipart);

  try {
    const { data: resp } = await axios({
      method,
      url: fullUrl,
      headers: { ...defaultHeaders, ...(config.headers || {}) },
      data,
      ...config,
    });
    return resp;
  } catch (err) {
    throw handleApiError(err);
  }
};


// تابع مدیریت خطاها
const handleApiError = (error: any) => {
  if (error.response) {
    const statusCode = error.response.status;
    const message = error.response.data?.message || "خطایی رخ داده است";
    throw new ApiError(message, statusCode);
  } else if (error.request) {
    throw new ApiError("پاسخی از سرور دریافت نشد", 500);
  } else {
    throw new ApiError(error.message, 500);
  }
};

// ++++ تغییرات اصلی اینجا اعمال شده ++++
export const get = (url: string, config?: AxiosRequestConfig) => apiRequest("GET", url, undefined, config);
export const post = (url: string, data: unknown, config?: AxiosRequestConfig) => apiRequest("POST", url, data, config);
export const put = (url: string, data: unknown, config?: AxiosRequestConfig) => apiRequest("PUT", url, data, config);
export const del = (url: string, data: unknown, config?: AxiosRequestConfig) => apiRequest("DELETE", url, data, config);
export const patch = (url: string, data: unknown, config?: AxiosRequestConfig) => apiRequest("PATCH", url, data, config);
// +++++++++++++++++++++++++++++++++++++++

export class ApiError extends Error {
  statusCode: number;
  constructor(message: string, statusCode: number) {
    super(message);
    Object.setPrototypeOf(this, ApiError.prototype);
    this.name = "ApiError";
    this.statusCode = statusCode;
  }
}

export const uploadMedia = async (
  url: string,
  formData: FormData,
  onUploadProgress?: (e: AxiosProgressEvent) => void
) => {
  const token = await getToken();
  return apiRequest("POST", url, formData, {
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    onUploadProgress,
  });
};


// اگر نمی‌خواهی کدهای دیگر بشکنند، uploadImage قدیمی را نگه دار:
export const uploadImage = async (
  formData: FormData,
  onUploadProgress?: (e: AxiosProgressEvent) => void
) => uploadMedia("/images-upload", formData, onUploadProgress);

export const handleError = (statusCode: number, message: string) => {
  switch (statusCode) {
    case 400:
      return { title: "درخواست نامعتبر", message };
    case 401:
      return { title: "عدم احراز هویت", message };
    case 403:
      return { title: "دسترسی ممنوع", message };
    case 404:
      return { title: "یافت نشد", message };
    case 500:
      return { title: "خطای سرور", message };
    default:
      return { title: `خطا ${statusCode}`, message };
  }
};

export const handleErrors = (error: unknown) => {
  console.info(error);
  if (error instanceof ApiError) {
    const { title, message } = handleError(error.statusCode, error.message);
    showToast(`${title} : ${message}`, "error");
  } else {
    showToast("مشکلی پیش آمده است", "error");
  }
};
